type MemberAreaPopoverActionsType = {
    $buttonsPopover: NodeListOf<HTMLButtonElement>|null,
    init(): void,
    openPopover($el: HTMLElement): void,
    closeAllPopover(): void,
};

const MemberAreaPopoverActions: MemberAreaPopoverActionsType = {
    $buttonsPopover: null,

    init() : void {
        this.$buttonsPopover = document.querySelectorAll<HTMLButtonElement>('.js-popover-button');

        if (this.$buttonsPopover) {
            document.addEventListener('click', e => {
                const $target = e.target as HTMLElement;

                if ($target.classList.contains('js-popover-button')) {
                    if (!$target.classList.contains('open')) {
                        this.closeAllPopover();
                        this.openPopover($target);
                    } else {
                        this.closeAllPopover();
                    }
                } else {
                    this.closeAllPopover();
                }
            });
        }
    },

    openPopover($el: HTMLElement) : void {
        $el.classList.add('open');
    },

    closeAllPopover() : void {
        this.$buttonsPopover?.forEach($button => {
            $button.classList.remove('open');
        });
    },
};

export default MemberAreaPopoverActions;
